import styled from "styled-components";
import { desktop, mobile } from "../../globalAssets/fontsize";
import { Col, Input, Typography } from "antd";
import { device } from "../../globalAssets/breakpoints";
import { BsFillUnlockFill, BsFillLockFill } from "react-icons/bs";
interface ToggleType {
  active: boolean;
}

export const TogglerContainer = styled.div`
  padding: 0.5vw;
  background: ${(props) => props.theme.foreground};
  width: 100%;
  background: ${(props) => props.theme.background};
  /* border-radius:4px; */
  box-shadow: ${(props) => props.theme.subtleShadow};
  display: flex;
  margin-bottom: 2vh;
`;
export const ActiveToggle = styled.div<ToggleType>`
  background: ${(props) =>
    props.active ? props.theme.secondaryColor : `none`};
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  padding: 0.2vw 0;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
  color: ${(props) => (props.active ? props.theme.white : props.theme.grey)};
`;

export const TextContainer = styled.div`
  width: 100%;
  position: sticky;
  height: 88vh;
  top: 8vh;
  background: none;
  & > div {
    color: ${(prop) => prop.theme.color};
  }
`;
export const Simplecontainer = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.highShadow};
  height: 100%;
  position: relative;
`;
export const Searchbar = styled.div`
  position: sticky;
  top: 0;
  padding: 20px 0;
  display: flex;
  width: 100%;
  background: ${(props) => props.theme.backgroundDim};
  box-shadow: ${(props) => props.theme.highBlueShadow};
  div {
    display: flex;
    background-color: #00000022;
    border-radius: 25px;
    padding: 1px 8px;
    width: 95%;
    margin: 0 auto;
  }
`;
export const StyledInput = styled(Input)`
  &&& {
    outline: none;
    padding: 6px 10px;
    margin: 0 5px;
    box-shadow: ${(props) => props.theme.subtleShadow};
    font-size: ${mobile.small};
    color: ${(props) => props.theme.color};
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .ant-input {
      box-shadow: ${(props) => props.theme.subtleShadow};

      color: ${(props) => props.theme.color};
      font-size: ${mobile.small};
    }
    @media ${device.laptop} {
      font-size: ${desktop.small};
      .ant-input {
        font-size: ${desktop.small};
      }
    }
  }
`;

export const SearchButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5vw 0.5vw;
  cursor: pointer;
  font-size: ${desktop.medium};
  width: max-content !important;
  background-color: transparent !important;
  color: ${(props) => props.theme.primaryColor};
`;
export const ContentContainer = styled.div`
  height: 95%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 2px;
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 20vh;
  }
`;
export const SingleChat = styled.div`
  padding: 12px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: ${(props) => `1px solid ${props.theme.separator}`};
  & > div {
    & > h3 {
      color: ${(props) => props.theme.color};
      font-size: 15px;
      font-weight: 600;
      margin: 0;
    }
    & > h5 {
      color: ${(props) => props.theme.grey};
      font-size: 12px;
      font-weight: 400;
      margin: 0;
    }
  }
  & > img {
    height: 2.5vw;
    width: 2.5vw;
    border-radius: 50%;
    margin-right: 1vw;
    flex-shrink: 0;
    flex-grow: 0;
    object-fit: cover;
  }
  :last-child {
    border: none;
  }
`;

export const CurrentChat = styled.div`
  padding: 13px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: ${(props) => props.theme.highBlueShadow};
  background: ${(props) => props.theme.backgroundDim};
  & > img {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    margin-right: 1vw;
    flex-shrink: 0;
    flex-grow: 0;
    object-fit: cover;
  }
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: 18px;
    font-weight: 500;
    margin: 0;
  }
`;

export const MessageContentContainer = styled.div`
  height: 75%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0.5vw 55px;
  width: 100%;
  &::-webkit-scrollbar {
    width: 2px;
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 20vh;
  }
`;

export const SendMessage = styled.div`
  /* background: green; */
  padding: 0.2vw 1vw;
  position: absolute;
  align-items: center;
  display: flex;
  bottom: 1vw;
  width: 100%;
`;
export const SendMessageInput = styled(Input.TextArea)`
  &&& {
    width: "100%";
    padding: 12px 10px;
    outline: none;
    /* font-size: 10px; */
    overflow-y: auto;
    background: none;
    color: ${(props) => props.theme.color};
    border: ${(props) => `1px solid ${props.theme.grey}`};
    height: 50px !important;
    border-radius: 25px;
    margin-right: 10px;
    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
      border-radius: 3px;
      margin: 17px 5px;
      /* padding: 10px 5px; */
      border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
    }
  }
  //
`;
export const TextChatInput = styled.input`
  width: 100%;
  &&& {
    width: "100%";
    padding: 12px 10px;
    outline: none;
    /* font-size: 10px; */
    overflow-y: auto;
    background: none;
    color: ${(props) => props.theme.color};
    border: ${(props) => `1px solid ${props.theme.grey}`};
    height: 50px !important;
    border-radius: 25px;
    margin-right: 10px;
    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
      border-radius: 3px;
      margin: 17px 5px;
      /* padding: 10px 5px; */
      border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
    }
  }
  //
`;
// export const MessageButton = styled.button`
// border:none;
// outline: none;
// font-size: 0.75vw;
// padding: 0.4vw 1.25vw;
// border-radius:4px;
// margin-left:1vw ;
// height:fit-content;
// font-weight:400;
// cursor:pointer;
// color:white;
// background:${props=>props.theme.primaryColor}
// `

export const MessageButton = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 2.6vw;
  cursor: pointer;
  width: 2.6vw;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  /* background:linear-gradient(145deg, "${(props) =>
    props.theme.primaryColor}" ,"${(props) => props.theme.secondaryColor}"); */
  background: linear-gradient(145deg, #4a7cf7, #0a6de6);
  color: ${(props) => props.theme.white};
  font-size: ${desktop.medium};
  box-shadow: 1px 1px 5px 0px #4a7cf788;
`;
export const CommunitySearchBar = styled.div``;
export const Topic = styled(Input)`
  &&& {
    width: "100%";
    padding-left: 10px;
    outline: none;
    font-size: 14px;
    overflow-y: auto;
    background: none;
    color: ${(props) => props.theme.color};
    border: ${(props) => `1px solid ${props.theme.subtleBlack}`};

    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.small};
      border-radius: 3px;
      border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
    }
  }
`;
export const SpaceListContainer = styled.div`
  padding: 1vw;
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: 16px;
    font-weight: 500;
    margin: 10px 0;
    @media ${device.laptop} {
      font-size: ${desktop.normal};
    }
  }
`;
export const SingleConvoCard = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  border-radius: 5px;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 95%;
  padding: 0.5vw;
  margin-right: auto;
  & > div {
    & > h4 {
      font-size: ${desktop.small};
      color: ${(props) => props.theme.primaryColor};
      font-weight: 600;
    }
  }
`;
export const StyledCol = styled(Col)`
  margin-bottom: 1vw;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    display: flex;
    align-items: center;
    font-size: ${desktop.small};
    font-weight: 500;
    & > h5 {
      color: ${(props) => props.theme.color};
      font-size: 0.75vw;
      margin: 0;
      margin-left: 0.1vw;
    }
  }
`;
export const LockIcon = styled(BsFillLockFill)`
  color: red;
  font-size: ${desktop.small};
`;
export const UnlockLockIcon = styled(BsFillUnlockFill)`
  color: #259b01;
  font-size: ${desktop.small};
`;
export const Description = styled(Typography.Paragraph)`
  color: ${(props) => props.theme.color};
  font-size: 0.75vw;
  font-weight: 500;
`;
export const ModalContainer = styled.div`
  padding: 16px 16px;
  border: none;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  & > .is-auth-room {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 7px 0 14px 0;
    align-items: center;
    & > p {
      color: ${(props) => props.theme.color};
    }
    & > input {
      background-color: transparent;
      width: max-content;
      outline: none;
      border: none;
      letter-spacing: 10px;
      border-bottom: 1px solid ${(props) => props.theme.grey};
      color: ${(props) => props.theme.color};
      :active {
        border-bottom: 1px solid ${(props) => props.theme.primaryColor};
      }
    }
  }
  & > h3 {
    text-align: center;
    font-weight: 500;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.normal};
    margin-bottom: 25px;
  }
  & > h2 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    & > span {
      font-weight: 600;
      color: ${(props) => props.theme.grey};
    }
  }
  & > h4 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    & > span {
      font-weight: 600;
    }
  }
  & > button {
    outline: none;
    border: none;
    align-self: center;
    color: white;
    background-color: ${(props) => props.theme.tint};
    padding: 5px 30px;
    border-radius: 20px;
    font-size: 15px;
    cursor: pointer;
  }
`;
export const CreateSpace = styled.div`
  color: ${(props) => props.theme.white};
  background: ${(props) => props.theme.linearGradient};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 23px 23px 7px 23px;
  padding: 10px 8px;
  font-size: ${desktop.small};
  font-weight: 500;
  width: 30px;
  height: 30px;
  white-space: nowrap;
  box-shadow: ${(props) => props.theme.highBlueShadow};
  transition: width 800ms;

  & > div {
    display: flex;
    align-items: center;

    /* margin-right: 5px; */
    font-size: ${desktop.normal};
  }
  & > h3 {
    font-size: 15px;
    color: ${(props) => props.theme.white};
    display: none;
    opacity: 0;
    margin: 0;
    text-overflow: ellipsis;
    word-wrap: none;
    transition: opacity 800ms 800ms;
  }
  :hover {
    width: 170px;

    & > h3 {
      display: flex;
      opacity: 1;
    }
  }
`;
export const SwitchTitle = styled.h3`
  font-size: ${desktop.small};
  color: ${(props) => props.theme.color};
`;
export const SwitchContainer = styled.div<{ showBg?: boolean }>`
  background: ${(props) => (props.showBg ? props.theme.foreground : "")};
  box-shadow: ${(props) => (props.showBg ? props.theme.highBlueShadow : "")};
  height: 100%;
`;

export const CommunityTopBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 0.5vw 1vw;

  justify-content: space-between;
  & > h3 {
    color: ${(prop) => prop.theme.color};
    font-size: 19px;
    font-weight: 600;
    margin: 0;
  }
  & > div {
    display: flex;
    align-items: center;
    img {
      height: 2vw;
      width: 2vw;
      border-radius: 5px;
      object-fit: cover;
    }
    & > h2 {
      margin: 0;
      /* margin-left: 1vw; */
      font-weight: 400;
      font-size: 0.9vw;
      color: ${(prop) => prop.theme.grey};
      & > span {
        font-weight: 500;
      }
    }
  }
`;
export const InSessionContainer = styled.div`
  height: 80%;
  overflow-y: auto;
  padding: 0.5vw 1vw;
  &::-webkit-scrollbar {
    width: 2px;
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 20vh;
  }
`;

export const SessionFooter = styled.div`
  height: 7%;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  /* background: ${(props) => props.theme.grey}; */
  justify-content: center;
  & > div {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-left: 2vw;
      display: flex;
      align-items: center;
      font-size: ${desktop.medium};
      cursor: pointer;
      & > h3 {
        /* color:${(props) => props.theme.color}; */
        font-size: ${desktop.small};
        font-weight: 500;
        margin: 0;
        margin-left: 0.5vw;
      }
    }
  }
`;

export const End = styled.div`
  background: ${(props) => props.theme.white};
  box-shadow: ${(props) => props.theme.subtleShadow};
  margin-left: 1vw;

  height: fit-content;
  display: flex;
  align-items: center;
  font-size: ${desktop.normal};
  cursor: pointer;
  color: red;
  padding: 0 0.5vw;
  & > h3 {
    color: red;
    font-size: ${desktop.small};
    font-weight: 500;
    margin: 0;
    margin-left: 0.5vw;
  }
`;
export const SpeakersList = styled.div`
  padding: 10px;
  border-radius: 10px;
  display: flex;
`;
export const SingleSpeaker = styled.div`
  margin-bottom: 1vw;
  display: flex;
  transition: all 250ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
  transition-delay: 500ms;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 120px;
  margin-right: max(0.8vw, 15px);
  & > .admin-settings {
    position: absolute;
    top: 0;
    left: 0px;
    width: max-content;
    cursor: pointer;
    & > .user-option {
      position: absolute;
      width: max-content;
      height: max-content;
      padding: 20px 20px;
      /* transform: rotateY(-180deg); */
      transition: opacity 500ms, transform 200ms;
      transition-delay: 500ms;
      :hover {
        transform: translateY(20px);
      }
      & > h6 {
        color: ${(prop) => prop.theme.grey};
        font-size: 11px;
      }
      & > div {
        position: relative;
        margin: 3px 0;
        cursor: pointer;
        font-size: 12px;
        :hover {
          &::after {
            width: 50px;
            content: "";
            position: absolute;
            bottom: 0px;
            left: 0px;
          }
        }
        &::after {
          height: 2px;
          width: 5px;
          transition: width 300ms;
          background-color: ${(prop) => prop.theme.tint};
        }
      }
    }
    :hover {
      perspective: 200px;
      width: 100%;
      /* transform: rotateY(180deg); */
      /* transition: 150ms; */
      /* transition-delay: 500ms; */
      .user-option {
        pointer-events: auto;
        opacity: 1;
      }
      /* & > *:not(.user-option) {
      transition: opacity 500ms;
      transition-delay: 500ms;
      opacity: 0;
    } */
    }
  }
  & > .pointer {
    position: absolute;
    top: 0;
    right: -1px;
    display: flex;
    justify-content: flex-end;
  }
  & > div {
    height: 85px;
    width: 85px;
    position: relative;
    & > img {
      height: 100%;
      width: 100%;
      border-radius: 10px;
      object-fit: cover;
    }
  }
  & > h3 {
    text-align: center;
    /* margin: 0; */
    margin-top: 10px;
    color: ${(props) => props.theme.color};
    font-size: 14px;
  }
`;
interface SoundType {
  speaker: boolean;
}
export const Sound = styled.div<SoundType>`
  height: 1.5vw;
  width: 1.5vw;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  right: -0.5vw;
  border-radius: 50%;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.shadow};
  color: ${(props) => (props.speaker ? `#259B01` : `red`)};
`;

export const ListenersList = styled.div`
  padding: 0.7vw;
  /* width: fit-content; */
  margin: 0 auto;
  display: flex;
  border-top: ${(props) => `1px solid ${props.theme.subtleBlack}`};
`;

export const UserChatInfoContainer = styled.div`
  width: 380px;
  height: 100%;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.shadow};
  display: flex;
  flex-direction: column;
  padding: 25px 15px;
  align-items: center;
`;
export const Property = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  & > h4 {
    color: ${(props) => props.theme.secondaryColor};
    margin: 10px 5px;
    font-size: ${mobile.normal};
  }
  & > h4:first-child {
    font-weight: 500;
  }
  @media ${device.laptop} {
    & > h4 {
      font-size: ${desktop.normal};
    }
  }
`;
